import logoGoldsand from "@/assets/logo-goldsand-v2.png";
import appStoreBadge from "@/assets/app_store_black.svg";
import googlePlayBadge from "@/assets/google_play.png";
import catGraphic from "@/assets/cat.png";
import { WEBSITE_BASE_URL, APPSTORE_LINK, PLAYSTORE_LINK } from "@/constants";

export default function Download() {
  return (
    <main className="min-h-[100vh] min-h-dvh bg-muted text-foreground">
      <section className="mx-auto w-full max-w-[1280px] min-h-[100vh] min-h-dvh grid grid-cols-1 lg:grid-cols-2">
        <div className="px-lg lg:px-xl py-xl lg:py-[72px] flex flex-col justify-between border-b border-border lg:border-b-0 lg:border-r lg:border-r-border">
          <a
            href={WEBSITE_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-sm w-fit opacity-95 hover:opacity-75 active:opacity-60 active:scale-[0.98] transition-all"
            aria-label="Go to Goldsand website"
          >
            <img
              src={logoGoldsand}
              alt="Goldsand logo"
              className="w-[100px] h-[100px] rounded-[8px] object-cover"
            />
            <span className="-ml-4 text-xl tracking-tight">Goldsand</span>
          </a>

          <div className="max-w-[540px] mt-lg sm:mt-xl lg:mt-0">
            <h1 className="text-[46px] leading-[1.08] tracking-tight sm:text-[58px] lg:text-[76px]">
              Download the<br />
              app
              to continue
            </h1>
            <p className="mt-md text-md text-muted-fg leading-relaxed max-w-[460px]">
              Download the Goldsand app to start earning.
            </p>
          </div>

          <img
            src={catGraphic}
            alt=""
            aria-hidden="true"
            className="hidden lg:block w-[250px] h-[250px] object-contain opacity-85"
          />
        </div>

        <div className="px-lg lg:px-xl py-xl lg:py-[72px] flex flex-col justify-center relative">
          <div className="w-full max-w-[440px] lg:ml-auto flex flex-col gap-lg">
            <div className="space-y-sm">
              <h2 className="text-xl leading-tight">Choose your app store</h2>
            </div>

              <div className="flex flex-col items-center gap-md">
                <a
                  href={APPSTORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download Goldsand on the App Store"
                  className="btn-primary inline-flex items-center justify-center rounded-md cursor-pointer opacity-95 hover:opacity-80 active:opacity-65 active:scale-[0.98] transition-all"
                >
                  <img
                    src={appStoreBadge}
                    alt="Download on the App Store"
                    className="h-[52px] w-auto"
                  />
                </a>

                <div className="w-full max-w-[280px] flex items-center gap-sm text-muted-fg/80">
                  <span className="h-px flex-1 bg-border" />
                  <span className="text-sm tracking-wide">or</span>
                  <span className="h-px flex-1 bg-border" />
                </div>

                <a
                  href={PLAYSTORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Get Goldsand on Google Play"
                  className="btn-primary inline-flex items-center justify-center rounded-md cursor-pointer opacity-95 hover:opacity-80 active:opacity-65 active:scale-[0.98] transition-all"
                >
                  <img
                    src={googlePlayBadge}
                    alt="Get it on Google Play"
                    className="h-[52px] w-auto"
                  />
                </a>
              </div>
            <p className="text-sm text-muted-fg leading-relaxed pt-sm lg:pt-0 lg:absolute lg:bottom-[72px] lg:right-xl lg:w-full lg:max-w-[440px]">
              Limited to certain jurisdictions. APY is subject to change. Other terms apply.
              Bank deposits are subject to additional eligibility and onboarding requirements.
              Availability may vary by device and region.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
